module.exports = __webpack_public_path__ + "static/media/Makeup02.28682613.jpeg";